import React, { useEffect, useRef } from "react";
import { Platform, Text } from "react-native";

/**
 * NoTranslateText component
 * Wraps text with translate="no" attribute to prevent Google Translate 
 * and other translation tools from translating the content.
 * 
 * This component uses a ref to directly set the translate attribute on the DOM node.
 * 
 * Usage:
 *   <NoTranslateText style={styles.yourStyle}>EFORT COACH</NoTranslateText>
 *   <NoTranslateText>Welcome to Efort Coach</NoTranslateText>
 *   <NoTranslateText>{t("newToEfortCoach-string")}</NoTranslateText>
 * 
 * Use this for brand names, proper nouns, or any text that should not be translated.
 */
const NoTranslateText = ({ children, style, ...props }) => {
  const textRef = useRef(null);

  useEffect(() => {
    if (Platform.OS === "web" && textRef.current) {
      // Access the underlying DOM node
      const node = textRef.current;
      if (node && node.setAttribute) {
        node.setAttribute('translate', 'no');
        node.classList.add('notranslate');
      }
    }
  }, []);

  return (
    <Text 
      ref={textRef}
      style={style} 
      {...props}
    >
      {children}
    </Text>
  );
};

export default NoTranslateText;
